
export default {
    name: "ListItem",
    props: {
        result: {
            type: Object,
            required: true,
            default: () => ({
                url: "",
                title: "",
                summary: "",
                tags: [],
                date: "",
                imageUrl: null,
                imageAltText: "",
                icon: null
            })
        }
    },
    setup() {
    }
}